import type { Lang } from './store';

export const t = {
  ro: {
    // header
    lang_ro: 'RO',
    lang_en: 'EN',

    // status pills
    pill_idle: 'Niciun drop activ',
    pill_active: 'Drop activ acum',
    pill_full: 'Drop complet',

    // idle
    idle_title_1: '5 câini.',
    idle_title_2: '5 comori.',
    idle_title_em: '10 minute.',
    idle_lead:
      'În fiecare săptămână un drop apare aleatoriu pe Instagram. Cei mai rapizi 5 ajung pe spațiul Sniffary. Restul stau pe lista de așteptare.',
    idle_card_title: 'Următorul drop e aproape',
    idle_card_text:
      'Drop-urile pică fără preaviz pe Instagram. Când unul se deschide, pagina asta începe să trăiască. Primele 5 click-uri câștigă.',
    how: 'Cum funcționează',
    steps: [
      { t: 'Drop pe Insta', d: 'Un cont (Sniffary, Boopr, Mash sau Arby\'s) postează „drop activ". Link aici.' },
      { t: 'Revendici locul', d: '5 locuri disponibile. Te înscrii cu detalii câine + 1 poză.' },
      { t: 'Treasure hunt', d: 'Pe un spațiu Sniffary. 10 min per câine. Primul obiect găsit, premiul tău.' },
    ],

    // active
    active_kicker: 'Drop activ',
    active_questN: 'Sniff Quest #',
    active_host_sniffary: 'gazdă: Sniffary',
    active_host_boopr: 'gazdă: Boopr',
    active_host_mash: 'gazdă: Mash',
    active_field: 'Spațiu',
    active_date: 'Data',
    active_time: 'Ora de start',
    spots_taken: 'din 5 locuri revendicate',
    slot: 'Locul',
    slot_available: 'disponibil',
    slot_confirmed: 'confirmat',
    slot_pending: 'așteaptă confirmare',
    waitlist_one: 'pe lista de așteptare',
    waitlist_many: 'pe lista de așteptare',
    confirm_in: 'mai are',
    confirm_hours_h: 'h',
    confirm_hours_m: 'm',
    confirm_expired: 'expirat',
    claim_button: 'REVENDICĂ LOCUL',
    claim_button_waitlist: 'ÎNSCRIE-TE PE LISTA DE AȘTEPTARE',
    claim_button_closed: 'DROP ÎNCHIS',
    claim_button_pending: 'Se trimite...',

    // full state
    full_title: 'Drop complet.',
    full_lead: 'Toate cele 5 locuri sunt revendicate. Următorul drop apare săptămâna viitoare. Fii primul data viitoare.',
    full_winners: 'Câștigătorii dropului',
    full_note: 'Vrei să prinzi următorul drop? Urmărește @sniffary, @boopr și @mash pe Instagram.',
    waitlist_explain: 'Top 5 e plin, dar înscrie-te pe waitlist. Locuri se eliberează frecvent în ultimele 12-24h pre-quest. Dacă cineva nu confirmă sau anulează, urci automat și primești email.',

    // form
    form_title: 'Revendică locul',
    form_subtitle: 'Locurile se completează în ordinea înscrierii. Completează rapid.',
    sec_dog: 'Despre câine',
    sec_owner: 'Despre stăpân',
    sec_consent: 'Acorduri',
    f_dog_name: 'Nume câine',
    f_dog_breed: 'Rasă',
    f_dog_breed_ph: 'ex: Labrador, Metis, Husky...',
    f_dog_age: 'Vârstă',
    f_dog_size: 'Talie',
    f_dog_gender: 'Gen',
    f_dog_city: 'Oraș',
    f_dog_superpower: 'Superputerea câinelui',
    f_dog_superpower_ph: 'ex: Adulmecă mâncare de la 100m',
    f_dog_hobby: 'Hobby preferat',
    f_dog_hobby_ph: 'ex: Furat șosete, înotat în orice baltă',
    f_dog_photo: 'Poză câine',
    f_dog_photo_hint: 'JPG sau PNG, min 600×600px',
    f_dog_photo_change: 'Schimbă poza',
    f_owner_name: 'Numele tău',
    f_handle: 'Handle Instagram',
    f_handle_ph: '@nume',
    f_email: 'Email',
    f_phone: 'Telefon',
    age_ranges: ['<1 an', '1-3 ani', '4-7 ani', '8+ ani'],
    sizes: ['mică (<10kg)', 'medie (10-25kg)', 'mare (>25kg)'],
    genders: ['mascul', 'femelă'],
    consent_terms: 'Am 18+ ani, am citit și sunt de acord cu <a href="/legal/regulament" target="_blank" rel="noopener" onclick="event.stopPropagation()">regulamentul</a>, <a href="/legal/termeni" target="_blank" rel="noopener" onclick="event.stopPropagation()">termenii</a> și <a href="/legal/confidentialitate" target="_blank" rel="noopener" onclick="event.stopPropagation()">politica de confidențialitate</a>',
    consent_content: 'Sunt de acord ca pozele și detaliile câinelui meu să fie folosite pe conturile Sniffary, Boopr, Mash și Arby\'s Treats pentru postări legate de campanie',
    consent_newsletter: 'Vreau notificări email la drop-urile viitoare',
    btn_submit: 'TRIMITE',
    btn_submit_loading: 'Se înscrie...',
    btn_cancel: 'Anulează',
    btn_reset_profile: 'Resetează datele salvate',

    // confirmation
    conf_title: 'e pe',
    conf_locul: 'LOCUL',
    conf_locul_din: 'din 5',
    conf_email: 'Verifică emailul ca să-ți confirmi locul în 12h.',
    conf_validate_title: 'Locul tău nu e încă asigurat',
    conf_validate_body: 'Locul va fi asigurat doar dacă validezi înscrierea prin email. Ai 12h.',
    conf_waitlist: 'ești',
    conf_waitlist_pos: 'pe lista de așteptare',
    conf_waitlist_note: 'Dacă cineva din top 5 nu confirmă, urci automat. Confirmă emailul oricum, ca să fii eligibil pentru promovare.',
    conf_close: 'Am înțeles!',

    // errors
    err_full: 'Locurile s-au epuizat în timp ce completai. Următorul drop, fii mai rapid.',
    err_dup: 'Acest email sau telefon e deja înscris la drop-ul curent.',
    err_strikes: 'Ai 2 sau mai multe drop-uri la care nu ai venit deși erai înscris. Înscrierile sunt suspendate. Scrie la contact@sniffary.ro dacă vrei să discutăm.',
    err_required: 'Câmp obligatoriu',
    err_email: 'Email invalid',
    err_photo: 'Adaugă o poză cu câinele',
    err_consent: 'Bifează acordurile obligatorii',

    // stats strip
    stat_spots: 'locuri',
    stat_drops: 'drop-uri',
    stat_dogs: 'câini',
    stat_label_summer: 'vara 2026',

    // footer
    powered_by: 'powered by',
    note: 'Vara 2026 · 1 iunie / 31 august',
  },

  en: {
    lang_ro: 'RO',
    lang_en: 'EN',

    pill_idle: 'No active drop',
    pill_active: 'Drop active now',
    pill_full: 'Drop full',

    idle_title_1: '5 dogs.',
    idle_title_2: '5 treasures.',
    idle_title_em: '10 minutes.',
    idle_lead:
      'Every week a drop appears at random on Instagram. The fastest 5 hit a Sniffary space. The rest sit on the waitlist.',
    idle_card_title: 'Next drop is close',
    idle_card_text:
      'Drops land without warning on Instagram. When one opens, this page comes alive. First 5 clicks win.',
    how: 'How it works',
    steps: [
      { t: 'Drop on Insta', d: 'One account (Sniffary, Boopr, Mash or Arby\'s) posts "drop active". Link here.' },
      { t: 'Claim your spot', d: '5 spots available. Sign up with dog details + 1 photo.' },
      { t: 'Treasure hunt', d: 'In a Sniffary space. 10 min per dog. First object found, your prize.' },
    ],

    active_kicker: 'Drop active',
    active_questN: 'Sniff Quest #',
    active_host_sniffary: 'host: Sniffary',
    active_host_boopr: 'host: Boopr',
    active_host_mash: 'host: Mash',
    active_field: 'Space',
    active_date: 'Date',
    active_time: 'Start time',
    spots_taken: 'of 5 spots claimed',
    slot: 'Slot',
    slot_available: 'available',
    slot_confirmed: 'confirmed',
    slot_pending: 'awaiting confirmation',
    waitlist_one: 'on waitlist',
    waitlist_many: 'on waitlist',
    confirm_in: 'has',
    confirm_hours_h: 'h',
    confirm_hours_m: 'm',
    confirm_expired: 'expired',
    claim_button: 'CLAIM YOUR SPOT',
    claim_button_waitlist: 'JOIN THE WAITLIST',
    claim_button_closed: 'DROP CLOSED',
    claim_button_pending: 'Sending...',

    full_title: 'Drop full.',
    full_lead: 'All 5 spots are claimed. Next drop opens next week. Be first then.',
    full_winners: 'The winners',
    full_note: 'Want to catch the next drop? Follow @sniffary, @boopr and @mash on Instagram.',
    waitlist_explain: "Top 5 is full, but join the waitlist. Spots open up often in the last 12-24h before the quest. If someone doesn't confirm or cancels, you move up automatically and we email you.",

    form_title: 'Claim your spot',
    form_subtitle: 'Spots fill in registration order. Be quick.',
    sec_dog: 'About your dog',
    sec_owner: 'About you',
    sec_consent: 'Consents',
    f_dog_name: 'Dog name',
    f_dog_breed: 'Breed',
    f_dog_breed_ph: 'ex: Labrador, Mix, Husky...',
    f_dog_age: 'Age',
    f_dog_size: 'Size',
    f_dog_gender: 'Gender',
    f_dog_city: 'City',
    f_dog_superpower: "Dog's superpower",
    f_dog_superpower_ph: 'ex: Sniffs food from 100m away',
    f_dog_hobby: 'Favorite hobby',
    f_dog_hobby_ph: 'ex: Stealing socks, swimming in any puddle',
    f_dog_photo: 'Dog photo',
    f_dog_photo_hint: 'JPG or PNG, min 600×600px',
    f_dog_photo_change: 'Change photo',
    f_owner_name: 'Your name',
    f_handle: 'Instagram handle',
    f_handle_ph: '@name',
    f_email: 'Email',
    f_phone: 'Phone',
    age_ranges: ['<1 yr', '1-3 yrs', '4-7 yrs', '8+ yrs'],
    sizes: ['small (<10kg)', 'medium (10-25kg)', 'large (>25kg)'],
    genders: ['male', 'female'],
    consent_terms: 'I am 18+, have read and agree to the <a href="/legal/regulament" target="_blank" rel="noopener" onclick="event.stopPropagation()">campaign rules</a>, <a href="/legal/termeni" target="_blank" rel="noopener" onclick="event.stopPropagation()">terms</a> and <a href="/legal/confidentialitate" target="_blank" rel="noopener" onclick="event.stopPropagation()">privacy policy</a>',
    consent_content: "I agree to my dog's photos and details being used on Sniffary, Boopr, Mash and Abry's Treats accounts for campaign posts",
    consent_newsletter: 'Email me about future drops',
    btn_submit: 'SUBMIT',
    btn_submit_loading: 'Submitting...',
    btn_cancel: 'Cancel',
    btn_reset_profile: 'Reset saved data',

    conf_title: 'is on',
    conf_locul: 'SLOT',
    conf_locul_din: 'of 5',
    conf_email: 'Check your email to confirm your spot within 12h.',
    conf_validate_title: 'Your spot is not locked yet',
    conf_validate_body: 'The spot is locked only after you validate via the email link. You have 12h.',
    conf_waitlist: "you're",
    conf_waitlist_pos: 'on the waitlist',
    conf_waitlist_note: "If anyone in top 5 doesn't confirm, you move up automatically. Confirm by email anyway, you need it to be eligible.",
    conf_close: 'Got it!',

    err_full: 'Spots filled while you were typing. Next drop, be quicker.',
    err_dup: 'This email or phone is already entered in this drop.',
    err_strikes: 'You missed 2 or more quests you were registered for. Sign-ups are suspended. Email contact@sniffary.ro if you want to talk.',
    err_required: 'Required',
    err_email: 'Invalid email',
    err_photo: 'Add a dog photo',
    err_consent: 'Tick the required consents',

    stat_spots: 'spots',
    stat_drops: 'drops',
    stat_dogs: 'dogs',
    stat_label_summer: 'summer 2026',

    powered_by: 'powered by',
    note: 'Summer 2026 · June 1 / August 31',
  },
} as const;

export function tr(lang: Lang) {
  return t[lang];
}
